import { render, staticRenderFns } from "./SelectCultura.vue?vue&type=template&id=bae5be9e&scoped=true&lang=pug"
import script from "./SelectCultura.vue?vue&type=script&lang=js"
export * from "./SelectCultura.vue?vue&type=script&lang=js"
import style0 from "./SelectCultura.vue?vue&type=style&index=0&id=bae5be9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae5be9e",
  null
  
)

export default component.exports